import { IDEMPOTENCY_OUTCOME_UNCERTAIN_CODE, REQUEST_TIMEOUT_CODE, RivetsApiError, WORKER_OUTCOME_UNKNOWN_CODE } from "@rivets/core";

/**
 * Whether an error leaves the outcome unknown: the worker went quiet mid
 * operation (504 `worker_outcome_unknown`, P3), the request may have landed
 * before it failed (409 `idempotency_outcome_uncertain`, P7), or our own
 * deadline ran out while the server carried on (`request_timeout`, review #2).
 * None is "failed": the caller reads the state back and says it is checking.
 * Every caller is a mutation; a read that times out is simply an error.
 */
export function isOutcomeUncertain(error: unknown): boolean {
  return error instanceof RivetsApiError
    && (error.code === WORKER_OUTCOME_UNKNOWN_CODE || error.code === IDEMPOTENCY_OUTCOME_UNCERTAIN_CODE
      || error.code === REQUEST_TIMEOUT_CODE);
}

/** "Lost contact with the worker during the commit — checking what happened…"
 * (the native `APIError.uncertainOutcomeMessage`). */
export function uncertainOutcomeMessage(during: string): string {
  return `Lost contact with the worker during ${during} — checking what happened…`;
}
